import CodecoApiTester from "@/pages/admin/codeco-api-tester/CodecoApiTester.vue";

const codecoApiTesterRoutes = [
  {
    path: "codeco-api-tester",
    name: "app-admin-codeco-api-tester",
    component: CodecoApiTester,
  },
];

export default codecoApiTesterRoutes;
